module.exports = {
    // basic
    'include-deleted-steps': 'incluir pasos eliminados',
    'pending': 'pendiente',
    'template-criteria': 'criterios de plantilla',
    'undo': 'anular',
    'reason-for-rejection': 'razón por rechazo',
    'dont-lock-entry': 'no bloquear entrada',
    'entry-rejection': 'entrada rechazada',


    // raw
    // template
};
